import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./columns";

export function HouseTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      apiEndpoint="/datagrid/house"
      getRowId={(row) => row.house.id}
      tableName="house"
      enableCreate={false}
      enableSearch={true}
      pageSizeOptions={[25, 50, 100, 250, 500]}
      height={"calc(100vh - 52.6px)"}
      initialStateOverride={{
        sorting: { sortModel: [{ field: "house.adddate", sort: "desc" }] },
      }}
    />
  );
}
